import { ref, toRefs } from 'vue';
import { defineStore } from 'pinia';
import useStoreGetters from './getters';
import useCoreStoreActions from './actions';
import {
  defaultPagination,
  IFilterItem,
  DeleteResult,
  CollapsibleContainerData,
  CollapsibleTableInnerContainerData,
  ListContainerData,
} from '../core/models';
import {
  TabsContainerData,
  CollapsibleTableContainerData,
  ConfirmationDialogData,
  FormContainerData,
  ICoreState,
  DrawerInfo,
  SizeInfo,
  TableContainerData,
  TableInnerContainerData,
  DrawerContainerData,
} from './models';

export const useCoreStore = defineStore('core', () => {
  const state = ref(<ICoreState>{
    useMiniForMainDrawer: false,
    useSilentApiCall: false,
    pendingRequests: [] as string[],

    toastMessage: undefined,
    tabsContainerData: new TabsContainerData(),
    collapsibleTableContainerData: new CollapsibleTableContainerData(),
    collapsibleTableInnerContainerData: new CollapsibleTableInnerContainerData(),
    tableContainerData: new TableContainerData(),
    tableInnerContainerData: new TableInnerContainerData(),
    collapsibleContainerData: new CollapsibleContainerData(),
    listContainerData: new ListContainerData(),
    formContainerData: new FormContainerData(),
    sizes: new SizeInfo(),
    confirmationDialogData: new ConfirmationDialogData(),
    drawerInfo: undefined as DrawerInfo | undefined,
    drawerContainerData: new DrawerContainerData(),
    breadcrumbItems: [],
    resetBreadcrumbs: false,
    activeContextMenuItem: undefined,
    deleteResult: {} as DeleteResult,

    //
    // Logs Table Container
    //
    logsTableContainerSearchBy: '',
    logsTableContainerPagination: defaultPagination,
    logsTableContainerSelectedRowKey: undefined as string | undefined,
    logsTableContainerFilters: [] as IFilterItem[],
  });

  return {
    ...toRefs(state.value),
    ...useStoreGetters(state),
    ...useCoreStoreActions(state),
  };
});
